import React, { useEffect, useState } from 'react';
import { useDashboardContext } from '../../../components/providers/DashboardProvider';
import { useAuth } from '../../../components/providers/AuthProvider';
import BlockCard from './BlockCard';
import { Box } from '@mui/material';
import RawDataPanel from '../RawDataPanel';
import UnavailableCard from '../UnavailableCard';
import battery_unavailable from '../../../assets/animations/unavailable/battery.gif';

const BatteryPage = () => {
  const { user } = useAuth();
  const isAdmin = user?.profile?.user_type === 'admin';

  const { pollingCounter } = useDashboardContext();
  
  const [init, setInit] = useState(true);

  const {
    fetchClusterBatteryData, batteryData,
  } = useDashboardContext();

  const runRoutine = async () => {
    console.log("Polling in Battery");
    fetchClusterBatteryData();
  }

  useEffect(() => {
    // console.log(batteryData);
  }, [batteryData]);

  useEffect(() => {
    if (init) {
      console.log("Initializing Battery page...");
      if (batteryData == null) {
        console.log("First poll...");
        runRoutine();
      }
      setInit(value => false);
    } else {
      if (pollingCounter != 0) {
        runRoutine();
      }
    }
  }, [pollingCounter]);

  useEffect(() => {
    // runRoutine();
  }, [])

  const blocks = Object.entries(batteryData?.blocks_data || {});

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
      pt: 2,
      gap: 2,
    }}>
      {blocks.map(([blockId, blockData]) => (
        <BlockCard
          key={blockId}
          id={blockId}
          data={blockData}
        />
      ))}

      {/* Data loaded but no battery blocks configured */}
      {batteryData && blocks.length === 0 &&
        <UnavailableCard
          title="Battery data unavailable"
          message="Battery data is not ready yet. Please contact your system administrator for more details."
          image={battery_unavailable}
        />
      }

      {batteryData && isAdmin && <RawDataPanel data={batteryData} />}
    </Box>
  )
}

export default BatteryPage;
